import React from 'react';
import {
  Box,
  Button,
  Padding,
  scrollToRefObject,
  Stack,
  Text,
} from '../../components';

export const HeaderModuleMobile = (props) => {
  let { reference } = props;
  const executeScroll = () => scrollToRefObject(reference);
  return (
    <>
      <Box ratio={1} backgroundImage={'images/header-module-picture.jpg'} />

      <Padding size={[5, 5, 6, 5]} backgroundRole="primary">
        <Stack size={3}>
          <Text textType="heading3">Join our team</Text>

          <Text textType="primary2">
            Glossier is giving voice through beauty as a direct-to-consumer
            company that leverages the power of personal narrative to own the
            beauty conversation on the internet.
          </Text>

          <Button
            borderSize={[1]}
            radius="small"
            borderRole="grey"
            backgroundRole="white"
            onClick={executeScroll}
          >
            Learn More
          </Button>
        </Stack>
      </Padding>
    </>
  );
};
